import React from "react";
import Banner from "../component/Banner";
import Header from "../component/header";
import Footer from "../component/Footer";
import Challenges from "../component/Challenges";
import CommunityShowcase from "../component/CommunityShowcase";
import BannerImg from "../image/guest.png";

function Guestchallenging() {
  return (
    <>
      <Header />
      <Banner
        backgroundImage={BannerImg}
        heading="What's Happening at LWBL"
        paragraph="Browse current quests, upcoming events, and community showcases before choosing where to enter your work. This is the LWBL schedule page for creative opportunities, gallery calls, and member gatherings."
        minHeight="100vh"
        padding="80px 0"
        bton="Sign in to enter"
      />
      <Challenges />
      <CommunityShowcase />
      <Footer />
    </>
  );
}

export default Guestchallenging;
